import type { SearchModalFilterChip } from '../interfaces/modalFilterChip.interface'

import { SearchFilterChip } from './SearchFilterChip'

import styles from '../SearchModal.module.scss'

type SearchChipsProps = {
  activeFilterChipId?: string | null
  filterChips?: readonly SearchModalFilterChip[]
  onFilterChipChange?: (id: string) => void
}

export function SearchChips({ activeFilterChipId, filterChips, onFilterChipChange }: SearchChipsProps) {
  if (filterChips === undefined || filterChips.length === 0) {
    return null
  }

  return (
    <div className={styles.chipsScroll}>
      {filterChips.map((chip) => {
        const disabled = chip.disabled || onFilterChipChange === undefined

        return (
          <SearchFilterChip
            key={chip.id}
            active={chip.id === activeFilterChipId}
            disabled={disabled}
            label={chip.label}
            onClick={() => {
              if (disabled || onFilterChipChange === undefined) {
                return
              }

              onFilterChipChange(chip.id)
            }}
          />
        )
      })}
    </div>
  )
}
